define(
({
  "alert": "Предупреждение",
  "okay": "Хорошо"
})
);
